import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { ErrorState, LoadingState } from '../../components/ui/state';
import { loadPublicGallery, publicGalleryCacheTime, publicGalleryQueryKey, type PublicGalleryKind } from './public-gallery-query';

export function PublicPhotoViewPage() {
  const { kind = 'stay', code = '', photoId = '' } = useParams();
  const galleryKind: PublicGalleryKind = kind === 'daycare' ? 'daycare' : 'stay';
  const galleryQuery = useQuery({
    queryKey: publicGalleryQueryKey(galleryKind, code),
    queryFn: () => loadPublicGallery(galleryKind, code),
    enabled: Boolean(code && photoId),
    staleTime: publicGalleryCacheTime,
  });
  const photo = galleryQuery.data?.photos.find((item) => item.id === photoId);

  if (galleryQuery.isLoading) return <main className="min-h-screen bg-[#f8faf6] p-5"><LoadingState label="Cargando foto" /></main>;
  if (galleryQuery.isError) return <main className="min-h-screen bg-[#f8faf6] p-5"><ErrorState message={galleryQuery.error.message} /></main>;

  return (
    <main className="min-h-screen bg-[#f8faf6] px-5 py-6 text-[#223126]">
      <div className="mx-auto max-w-5xl space-y-4">
        <Link className="inline-flex h-9 items-center gap-2 rounded-md border border-[#d6ded0] bg-white px-3 text-sm font-medium text-[#334033] hover:bg-[#eef3ea]" to="/photos">
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Volver
        </Link>
        {photo ? (
          <figure className="overflow-hidden rounded-lg border border-[#d9dfd1] bg-white shadow-sm">
            <img src={photo.downloadUrl} alt={photo.fileName} className="max-h-[78vh] w-full object-contain" />
            <figcaption className="border-t border-[#d9dfd1] p-3 text-sm font-medium">{photo.fileName}</figcaption>
          </figure>
        ) : (
          <ErrorState message="No encontramos esta foto." />
        )}
      </div>
    </main>
  );
}
